(function () {
  if (typeof window === "undefined") return;
  if (window.__amMotion) return;
  window.__amMotion = true;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var SELECTOR = ".am-hero, .am-section, .am-full, .am-split, .am-footer, .am-pdp, .am-about-hero, .am-about-quad";

  function bind(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -6% 0px" }
    );

    nodes.forEach(function (el) {
      if (el.classList.contains("am-reveal")) {
        io.observe(el);
        return;
      }
      el.classList.add("am-reveal");
      io.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bind(event.target);
  });
})();
